import { contentPath, gcsPublicConfigured, gcsReadPublic, listPublished } from "../storage";
import { parseFrontmatter } from "./frontmatter";
import { normalizeEntry, splitImpactSlug } from "./entryModel";

// Impact pages are markdown docs in the public bucket under
// production/content/impact/<institution>-<page>.md, published from /admin.
// The overview, the homepage and each case study list them from here, so a
// page published or deleted in the admin shows up (or disappears) everywhere.

async function loadImpactPage(slug) {
	try {
		const raw = await gcsReadPublic(contentPath("production", "impact", slug));
		if (!raw) return null;
		const { meta, body } = parseFrontmatter(raw);
		const entry = normalizeEntry("impact", slug, meta, body);
		return { ...entry, body, pageSlug: splitImpactSlug(slug, entry.institution).page };
	} catch (err) {
		console.error(`Failed to load impact/${slug}:`, err);
		return null;
	}
}

const pinnedThenNewest = (a, b) =>
	Number(b.pinned) - Number(a.pinned) || String(b.date).localeCompare(String(a.date));

/**
 * Every published Impact page (normalizeEntry shape + body + pageSlug), pinned
 * first, then newest first. A pinned page is a case study: same doc, shown as
 * a line above the cards. Pages that fail to load are skipped; throws when the
 * bucket listing fails, so callers can show an error state.
 */
export async function loadPublishedImpact() {
	if (!gcsPublicConfigured()) return [];
	const published = await listPublished("impact");
	const pages = await Promise.all(published.map(({ slug }) => loadImpactPage(slug)));
	return pages.filter(Boolean).sort(pinnedThenNewest);
}
